import Pricing from './Pricing.page';

export default Pricing;
